import { IconProps } from '.';

const SwatchesIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142907)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.03683 7.32338C6.39735 7.5835 6.08982 8.31277 6.34994 8.95224L6.86292 10.2134L6.66833 10.7137L0.834994 25.7137C0.713884 26.0252 0.722504 26.3721 0.858928 26.6772C0.995353 26.9822 1.24822 27.2199 1.5611 27.3372L7.41667 29.5331V30.3335C7.41667 31.0238 7.97631 31.5835 8.66667 31.5835H15.5556L15.8932 32.4136C16.1533 33.0531 16.8826 33.3606 17.5221 33.1005L33.6518 26.5395C34.2912 26.2794 34.5988 25.5501 34.3387 24.9106L24.7954 1.44927C24.5353 0.809791 23.806 0.50226 23.1665 0.762377L7.03683 7.32338ZM7.41667 26.8631V15.687L3.62359 25.4407L7.41667 26.8631ZM9.91667 29.0835V17.7207L14.5386 29.0835H9.91667ZM17.738 30.3138L9.13667 9.16815L22.9506 3.54911L31.5519 24.6947L17.738 30.3138ZM14.7863 12.7988C13.9328 13.1436 12.9614 12.7313 12.6166 11.8779C12.2718 11.0244 12.6841 10.053 13.5376 9.70821C14.3909 9.36339 15.3624 9.7757 15.7073 10.6292C16.0521 11.4826 15.6398 12.454 14.7863 12.7988Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142907">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SwatchesIcon;
